module.exports = __webpack_public_path__ + "img/download-outline.29aca063.svg";